import dayjs from "dayjs";
import Link  from "next/link";
import React from "react";

import Image      from "_components/atoms/image";
import Typography from "_components/atoms/typography";
import useStyles  from "_styles/pages/blogs/categoryPost.js";

const CategoryPost = ( { post } ) => {
	const { classes }                                                     = useStyles ( undefined, { name: "styles" } );
	const { featuredImage, title, categoryName, content, date, id, slug } = post;

	const link = `/blogs/${ slug }/${ id }`;

	return (
		<div>
			<Link className = { classes.categoryPostWrapper }
				href = { link }
			>
				<Image
					alt       = "img"
					className = { classes.categoryPostImage }
					src       = { featuredImage }
				/>

				<div className = { classes.infoContainer }>
					<Typography
						className = { classes.heading }
						dangerouslySetInnerHTML = { { __html: title } }
					/>

					<div
						className = { classes.postContent }
						dangerouslySetInnerHTML = { { __html: content } }
					/>

					<div className = { classes.tagsContainer }>
						<Typography
							className = { classes.dateTag }
							title = { dayjs ( date ).format ( "MMMD" ) }
						/>

						<div className = { classes.seperator } />

						<Typography
							className = { classes.nameTag }
							title = { categoryName }
						/>
					</div>

				</div>
			</Link>
		</div>
	);
};

export default CategoryPost;
